<template>
  <div class="text-center">
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <v-card-title class="text-h6 primary white--text"> Selecione as turmas </v-card-title>

        <v-select
          class="px-3 my-5"
          :items="turmasList"
          item-text="descricao"
          item-value="id"
          multiple
          return-object
          label="Selecione pelo menos uma turma"
          v-model="turmasSelecionadas"
        ></v-select>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="$emit('dialogChange', false)"> Fechar </v-btn>
          <v-btn
            color="primary"
            text
            @click="confirmarSelecao"
            :disabled="turmasSelecionadas.length < 1"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirmacao" persistent width="600" max-width="90vw">
      <v-card>
        <v-card-title class="text-h6 warning white--text d-flex align-center">
          <v-icon color="white" class="mr-2">mdi-alert-circle</v-icon>
          Confirmação necessária
        </v-card-title>

        <v-card-text class="py-6">
          <div class="text-center mb-4">
            <v-icon color="warning" size="48">mdi-clock-alert</v-icon>
          </div>

          <div class="text-center mb-4">
            <h3 class="text-h6 mb-2">Você selecionou {{ turmasSelecionadas.length }} turmas</h3>
            <p class="text-body-2 grey--text">
              Processar acima de 5 turmas pode impactar a performance
            </p>
          </div>

          <v-divider class="mb-4"></v-divider>

          <div class="mb-4">
            <p class="text-body-2 font-weight-medium mb-2">Turmas selecionadas:</p>
            <div class="d-flex flex-wrap" style="max-height: 120px; overflow-y: auto">
              <v-chip
                v-for="turma in turmasSelecionadas"
                :key="turma.id"
                class="ma-1"
                small
                outlined
                color="primary"
              >
                {{ turma.descricao }}
              </v-chip>
            </div>
          </div>

          <v-alert type="info" outlined dense class="mb-0" icon="mdi-information">
            <div class="text-body-2">
              <strong>Tempo estimado:</strong> Esta operação pode levar alguns minutos para ser
              concluída.
              <br />
              <strong>Recomendação:</strong> Considere processar as turmas em lotes menores (1-5)
              para melhor performance.
            </div>
          </v-alert>
        </v-card-text>

        <v-card-actions class="px-6 pb-4">
          <v-btn color="grey" text @click="dialogConfirmacao = false" class="mr-2">
            <v-icon left>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="warning" depressed @click="prosseguirMesmoAssim">
            <v-icon left>mdi-check</v-icon>
            Continuar mesmo assim
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    franquia_id: {
      type: Number,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    tipoRelatorio: {
      type: String,
      default: "professor",
    },
  },
  data() {
    return {
      turmasList: [],
      turmasSelecionadas: [],
      dialogConfirmacao: false,
    };
  },
  watch: {
    dialog: {
      async handler(newVal) {
        if (newVal) {
          await this.listarTurmasFranquiaSelect(this.franquia_id);
        } else {
          this.turmasSelecionadas = [];
        }
      },
    },
  },
  methods: {
    async listarTurmasFranquiaSelect(franquia) {
      this.carregandoTurmas = true;
      try {
        const response =
          await this.$services.turmasService.listarTurmasFundamentalEInfantilFranquia({
            franquia_id: franquia,
          });
        this.turmasList = response;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.carregandoTurmas = false;
      }
    },
    confirmarSelecao() {
      if (this.turmasSelecionadas.length > 5) {
        this.dialogConfirmacao = true;
      } else {
        this.gerarRelatorio();
      }
    },

    async prosseguirMesmoAssim() {
      this.dialogConfirmacao = false;
      await this.gerarRelatorio();
    },

    async gerarRelatorio() {
      this.$loaderService.open("Carregando dados... Isso pode demorar um pouco.");
      try {
        const turmasIds = this.turmasSelecionadas.map((turma) => turma.id);
        if (this.tipoRelatorio === "professor") {
          await this.$services.relatoriosService.DesempenhoProfessorPorTurma(
            this.franquia_id,
            turmasIds
          );
        } else if (this.tipoRelatorio === "aluno") {
          await this.$services.relatoriosService.DesempenhoAlunoPorTurma(
            this.franquia_id,
            turmasIds
          );
        } else {
          await this.$services.relatoriosService.DesempenhoCoordenadorPorTurma(
            this.franquia_id,
            turmasIds
          );
        }
        this.$emit("dialogChange", false);
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    limitTurmas(value) {
      if (value.length > 5) {
        return "Você pode selecionar no máximo cinco turmas.";
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped></style>
